import React, { useEffect, useState } from 'react';

import styled from 'styled-components';

import { PropTypes } from 'prop-types';

import {
   BottomMargin,
   CenteredFlexContainer,
   Description,
   ExtButton,
   Notification,
   StaticCol,
} from '../../../styledComponents/styledComponents';
import { uniqueIdFactory } from '../../../util/UtilFunctions';
import { Collapse, Input, PopoverBody, PopoverHeader, UncontrolledPopover } from 'reactstrap';
import { Tooltip as ReactTooltip } from 'react-tooltip/dist/react-tooltip.umd';
import useBlockAction, { getBlockErrorMessage } from '../../../hooks/useBlockAction';
import { IP_BLOCKLIST } from '../../../constants/general';

export const VariableWidthPopover = styled(UncontrolledPopover)`
   max-width: 500px !important;
`;
VariableWidthPopover.displayName = 'VariableWidthPopover';

function BlockingButton({ valueToBeBlocked, type, isBlocked: initialIsBlocked = false, onActionSuccess }) {
   const [uid] = useState(uniqueIdFactory('_'));
   const [localIsBlocked, setLocalIsBlocked] = useState(initialIsBlocked);
   const [isConfirmOpen, setConfirmOpen] = useState(false);
   const [tagInput, setTagInput] = useState('');

   const typeDescription = type === IP_BLOCKLIST ? 'IP' : 'Referrer';

   const { block, unblock, isSuccess, error, reset } = useBlockAction({ valueToBeBlocked, type });

   useEffect(() => {
      if (isSuccess) {
         setLocalIsBlocked((prev) => !prev);
         setConfirmOpen(false);
         setTagInput('');
         reset();
         if (onActionSuccess) onActionSuccess();
      }
   }, [isSuccess, reset, onActionSuccess]);

   return (
      <>
         <ExtButton
            id={`Popover${uid}`}
            type='button'
            $widthPx={30}
            $bgColor={'#c8ced3'}
            $color={'#23282c'}
            $bgColorHover={'rgb(255, 147, 63)'}
            $fontColorHover={'#FFF'}
            $paddingPx={'3px'}
            $lineHeight={0.1}
            $border={'0px solid black'}
            data-tooltip-id={'BlockPopover'}
            data-tooltip-html={'Configure IP Block'}
            onClick={() => {
               setConfirmOpen(false);
               reset();
            }}
         >
            <svg
               xmlns='http://www.w3.org/2000/svg'
               width='10'
               height='10'
               fill='currentColor'
               className='bi bi-wrench'
               viewBox='0 0 16 16'
            >
               <path d='M.102 2.223A3.004 3.004 0 0 0 3.78 5.897l6.341 6.252A3.003 3.003 0 0 0 13 16a3 3 0 1 0-.851-5.878L5.897 3.781A3.004 3.004 0 0 0 2.223.1l2.141 2.142L4 4l-1.757.364L.102 2.223zm13.37 9.019.528.026.287.445.445.287.026.529L15 13l-.242.471-.026.529-.445.287-.287.445-.529.026L13 15l-.471-.242-.529-.026-.287-.445-.445-.287-.026-.529L11 13l.242-.471.026-.529.445-.287.287-.445.529-.026L13 11l.471.242z' />
            </svg>
         </ExtButton>
         <ReactTooltip
            id={'BlockPopover'}
            place={'top'}
            className={'reduced-line-height bring-on-top'}
            backgroundColor={'rgba(0,0,0,0.9)'}
            textColor={'rgb(240,240,240)'}
            style={{ textAlign: 'center' }}
         />
         <VariableWidthPopover trigger='legacy' placement='bottom' target={`Popover${uid}`}>
            <PopoverHeader>{`${localIsBlocked ? 'Unblock' : 'Block'} configuration`}</PopoverHeader>
            <PopoverBody className='py-3'>
               <CenteredFlexContainer $direction={'column'} vertical={'center'} $width={'220px'}>
                  <Collapse isOpen={!isConfirmOpen}>
                     {!localIsBlocked && (
                        <BottomMargin pxSize={15}>
                           <Description>
                              <div>
                                 <b>Note:</b> The block only affects new connections or the next reconnect and takes
                                 max. 6 minutes to be effected.
                              </div>
                              <div>Blocking for a running playout requires a reconnect to take effect.</div>
                              <div>Blocked IPs will be automatically unblocked after 24 hours.</div>
                           </Description>
                        </BottomMargin>
                     )}
                     <ExtButton
                        type='button'
                        $widthPx={140}
                        $bgColor={'rgb(255, 147, 63)'}
                        $color={' #FFF'}
                        $bgColorHover={'rgb(255, 147, 63)'}
                        $fontColorHover={' #FFF'}
                        $xCentered
                        onClick={localIsBlocked ? unblock : () => setConfirmOpen(true)}
                     >
                        {localIsBlocked ? `Unblock ${typeDescription}` : `Block ${typeDescription}`}
                     </ExtButton>
                     <Collapse isOpen={!!error}>
                        <Notification topMarginPx={15} textAlign={'center'}>
                           {getBlockErrorMessage(error, 'Unblock failed, please try later again.')}
                        </Notification>
                     </Collapse>
                  </Collapse>
                  <Collapse isOpen={isConfirmOpen}>
                     <BottomMargin pxSize={15}>
                        <Description $xCentered>Optional comment</Description>
                        <StaticCol width={170}>
                           <Input value={tagInput} onChange={(event) => setTagInput(event.target.value)} />
                        </StaticCol>
                     </BottomMargin>
                     <BottomMargin>
                        <ExtButton
                           type='button'
                           $widthPx={140}
                           $bgColor={'rgb(255, 147, 63)'}
                           $color={' #FFF'}
                           $bgColorHover={'rgb(255, 147, 63)'}
                           $fontColorHover={' #FFF'}
                           $xCentered
                           onClick={() => block(tagInput)}
                        >
                           {'Confirm block'}
                        </ExtButton>
                     </BottomMargin>
                     <ExtButton
                        type='button'
                        $widthPx={140}
                        $bgColor={'rgb(100,100,100)'}
                        $color={' #FFF'}
                        $bgColorHover={'rgb(100,100,100)'}
                        $fontColorHover={' #FFF'}
                        $xCentered
                        onClick={() => {
                           setConfirmOpen(false);
                           reset();
                        }}
                     >
                        {'Abort block'}
                     </ExtButton>
                     <Collapse isOpen={!!error}>
                        <Notification topMarginPx={15} textAlign={'center'}>
                           {getBlockErrorMessage(error, 'Block failed, please try later again.')}
                        </Notification>
                     </Collapse>
                  </Collapse>
               </CenteredFlexContainer>
            </PopoverBody>
         </VariableWidthPopover>
      </>
   );
}

BlockingButton.propTypes = {
   valueToBeBlocked: PropTypes.string,
   type: PropTypes.string,
   isBlocked: PropTypes.bool,
   onActionSuccess: PropTypes.func,
};

export default BlockingButton;
